<template>
  <div style='background:white;' class='' v-loading='loading'>
  
    <tyc :tqobj='tqobj'></tyc>

    <el-dialog class='gDia' @close='closeDia' v-loading='loading' :title="$t('app_adddv')" v-model="dialogVisible" size=''>

      <el-row>
        <el-col :span='6' :gutter='10'>
          <div class=''>
            <el-button :disabled="multipleSelection.length == 0" @click='bcbind' type='primary'>{{$t('app_mulAdd')}}</el-button>
          </div>
        </el-col>
        <el-col :offset="0" :span='6' :gutter='20'>
          <div style='padding-right: 8px;'>
            <el-select @change='srchDevice' style='' v-model="status" clearable :placeholder="$t('app_status')">
              <el-option
                v-for="item in stModel"
                :key="item.vl"
                :label="item.lb"
                :value="item.vl">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :offset="0" :span='6' :gutter='10'>
          <div class=''>
            <MechanismSelector style='' :data="mechanismData1" ></MechanismSelector>
          </div>
        </el-col>
        <el-col :span='6' >
          <div style='padding-left:8px;'>
            <el-input
            :placeholder="$t('app_searchTerminal')"
            icon="search"
            :on-icon-click="srchDevice"
            @keyup.enter.native='srchDevice'
            style=''
            v-model="srchValue">
            </el-input>
          </div>
        </el-col>
      </el-row>


      <el-table
      :data="tableData"
      ref="multipleTable"
      @selection-change="handleSelectionChange"
      border
      class='gTopMg'
      tooltip-effect="dark"
      style="width: 100%">
        <el-table-column
          align=center
  	      type="selection"
  	      width="55">
  	    </el-table-column>
        <el-table-column
          align='center'
          prop="terminalNo"
          :label="$t('app_terNo')"
          width="150">
        </el-table-column>
        <!-- <el-table-column
          align='center'
          prop="terminalName"
          :label="$t('app_terName')"
          width="130">
        </el-table-column> -->
        <el-table-column
          prop="terminal_status"
          align='center'
          :label="$t('app_status')"
          width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('app_online')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 2 " type="danger" size="mini">{{$t('app_offline')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('app_new')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 3 " type="warning" size="mini">{{$t('app_sleep')}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align='center'
          prop="mechName"
          :label="$t('app_distributor')"
          width=''>
        </el-table-column>
        <el-table-column
          prop="operate"
          :label="$t('app_operate')" 
          align='center'
          width='80'>
          <template slot-scope='scope'>
            <!-- <el-button  @click='pushInstall(scope.row)' type=text>{{$t('app_push')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_add')" placement="top">
              <el-button type='text'  @click='bindOp(scope.row)'><i class="fa fa-plus" style=""></i></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <div class="gPgDiv" style=''>

        <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
        <!-- <el-pagination
          small
          layout="prev, pager, next"
          :total="total">
        </el-pagination> -->

      </div>
    </el-dialog>

    <el-button @click='editCf' type="primary">{{$t('app_editconfig')}}</el-button>
    
    <div v-show="true" class='gPageBorder gTopMg'>
      <div style='display:inline-block;width:calc(100% - 48px);height:100%;margin-bottom:0px;background:none;padding:0 0px 12px 24px'>
        <div style='height:64px;'>
          <button class='dt-word-main' style='padding:0;height:100%;font-size:22px;background:none;border:none;'>{{config ? config.configName : ''}}</button>
        </div>

        <div style='height:30px;' v-for='item in dtGroup'>
          <table class='lcpush'>
            <tr>
              <td v-for='sitem in item'>
                <label class='dt-word-title'>{{sitem.tt}}：</label>
                <label class='dt-word-main'>{{sitem.vl}}</label>
              </td>
              <td>
              </td>
            </tr>
            
          </table>
        </div>

        <div style='min-height:10px;display:flex;display:-webkit-flex;'>
          <div class='dt-word-title' style='display:inline-block;min-width:70px;'>
            <label >{{$t('app_filestss')}}：</label>
          </div>
          <div class='dt-word-main' style='display:inline-block;position:relative;background:none;'>
            <pre >{{config? config.configDesc : ''}}</pre>
          </div>
        </div>
      </div>
    </div>

    <div class='gPageBorder gTopMg' v-show="true" style=''>
      
      <p class='gCtColor gPTitle' style=''>{{$t('app_dvconfiglist')}} </p>

      <el-row>
        <el-col :span='12'>
          <div class='gSgLeftBtn'>
            <el-button  v-show="true"  @click="addTer" type='primary'  class=''>{{$t('terminal.list.add_btn')}}</el-button>
            <el-button  v-show="true"  @click="getList()" type=''  class=''>{{$t('lin_global.shuaxin')}}</el-button>
          </div>
        </el-col>


        <el-col :span="4">
            <div class='gCtrl'>
              <el-select  v-model="bindVl" clearable :placeholder="$t('app_type')" @change='selectChange'>
                <el-option
                  v-for="item in bindSts"
                  :key="item.vl"
                  :label="item.lb"
                  :value="item.vl">
                </el-option>
              </el-select>
            </div>
          </el-col>

        <el-col :span="4">
            <div class='gCtrl'>
              <!-- <el-select  v-model="appType" clearable :placeholder="$t('app_type')" @change='selectChange'>
                <el-option
                  v-for="item in appTypes"
                  :key="item.appClassifyId"
                  :label="item.appClassifyName"
                  :value="item.appClassifyId">
                </el-option>
              </el-select> -->
              <MechanismSelector style='' :data="mechanismData"></MechanismSelector>
            </div>
          </el-col>
            

          <el-col :span="4">
            <div class='gSideCtrl'>
              <el-input  :placeholder="$t('app_name') + ' & ' + $t('app_number')" v-model='queryKey' @keyup.enter.native='query' icon="search" :on-icon-click="query"></el-input>
            </div>
          </el-col>
      </el-row>

      
      
      <el-table
        :data="hiss"
        border
        class='gTopMg'
        @sort-change="sortChange"
        style="width: 100%;">
        <el-table-column
          header-align='center'
          align='center'
          prop="terminalName"
          sortable="custom"
          :label="$t('app_deviceName')"
          width="">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="terminalNo"
          sortable="custom"
          width=''
          :label="$t('app_deviceNo')">
        </el-table-column>


        <!-- <el-table-column
          header-align='center'
          align='center'
          prop="status"
          width='115'
          :label="$t('app_vStatus')">
          <template slot-scope='scope'>
            <label :style='getStatus(scope.row.status).style'>{{getStatus(scope.row.status).vl}}</label>
          </template>
        </el-table-column> -->


        <el-table-column
          header-align='center'
          align='center'
          prop="mechName"
          width=''
          :label="$t('app_distributor')">
        </el-table-column>

        <el-table-column
          header-align='center'
          align='center'
          prop="version"
          fformatter="showBindSt"
          width=''
          :label="$t('app_appconfigst')">
          <template slot-scope=scope>
            <label :style="stcolor(scope.row.useStatus)">{{bindSt[scope.row.useStatus]}}</label>
          </template>
        </el-table-column>
       
        <el-table-column
          header-align='center'
          align='center'
          fformatter="dateFormat"
          prop="opeTime"
          sortable="custom"
          width='170'
          :label="$t('app_applytime')">
        </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop=""
          width='86'
          :label="$t('app_operate')">
          <template slot-scope='scope' >
            
            <!-- <el-button v-show='scope.row.isoperate === 0' type=text @click='deleteApp(scope.row)'>{{$t('app_del')}}</el-button> -->
            <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top" v-show='scope.row.status != 1'>
              <el-button type='text' @click='unbind(scope.row)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
            </el-tooltip>

            <el-tooltip class="item" effect="dark" :content="$t('lin_global.chongtui')" placement="top" v-show='scope.row.useStatus == 2'>
              <el-button type='text' @click='repush(scope.row)'><i class="fa fa-refresh" style=""></i></el-button>
            </el-tooltip>

          </template>
        </el-table-column>
      </el-table>

      <div class="gPgDiv" style='gPgDiv'>

        <el-pagination
        class='gPg'
        @current-change="pageChange"
        @size-change="pageSize"
        :current-page="page"
        :page-sizes='$gRows'
        :page-size="$gRow"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
        </el-pagination>

      </div>
    </div>
  

  </div>
</template>

<style>
  .dt-word-main{color:rgb(72,87,106)}
  .dt-word-title{color:#99A9BF;}
  pre{
    white-space: pre-wrap;
    word-wrap: break-word;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-break:break-all;
    font-family: inherit;
  }

  .dt-launch{width:100%;height:100%;background:none;}
    .dt-launch td{width:20%;}

 
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  
  .capture {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width:120px;
    display:inline-block;
  }
  .capture div{float:left;}

  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height:128px;
    line-height: 128px;
    text-align: center;
  }

  .sm-avatar-uploader-icon {
    font-size: 36px;
    color: #8c939d;
    width: 72px;
    height:72px;
    line-height: 72px;
    text-align: center;
  }
  .sm-avatar {
    width: 64px;
    height: 64px;
    display: block;
  }
 
</style>

<script>
  import mm from 'moment'
  import tyc from '@/components/global/tyc'
  import df from '../../../assets/df.png'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
import { clearTimeout } from 'timers';
  export default {
    data () {
      var _this = this
      return {
        orderName: '',
        orderType: '',
        stModel: [],
        status: '',
        tqobj: '',
        rfDuration: 10,
        detailId: '',
        mechanismData: {
          callback (value) {
            _this.mech = value
            // that.selectChange(value)
            _this.getList()
          }
        },
        dtGroup: [],
        mechanismData1: {
          callback (value) {
            _this.mech1 = value
            // that.selectChange(value)
            _this.getDevices()
          }
        },
        mech: '',
        mech1: '',
        srchValue: '',
        multipleSelection: [],
        detail: '',
        dialogVisible: false,
        mapType: {
          '0': this.$t('app_bdmap'),
          '1': 'Google' + this.$t('app_map')
        },
        ctrlType: { 
          '0': this.$t('app_close'),
          '1': this.$t('app_open1'),
        },
        bindSt: {
          '0': this.$t('app_waitupdate'),
          '1': this.$t('app_updateSuccess'),
          '2': this.$t('app_updateFail'),
          '3': this.$t('app_downFinish'),
          '4': this.$t('app_md5Fail')
        },
        bindSts: [
          {vl:'', lb: this.$t('app_allstatus')},
          {vl:'0', lb: this.$t('app_waitupdate')},
          {vl:'1', lb: this.$t('app_updateSuccess')},
          {vl:'2', lb: this.$t('app_updateFail')},
          {vl:'3', lb: this.$t('app_downFinish')},
          {vl:'4', lb: this.$t('app_md5Fail')}
        ],
        bindVl: '',
        config: '',
        captures: [],
        loading: 0,
        tableData: [],
        tags: [],
        page: 1,
        index:1,
        hiss: [],
        pageTotal: 0
      }
    },
    components: {
      MechanismSelector,tyc
    },
    computed: {
    
      showUploadNew () {
        //console.log('ccc', this.config.data)
        if (this.config) {
          if (this.config.isoperate === 0) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      }
    },
    methods: {
      repush (row) {        
        this.loading = 1
        this.$repushDSFailDv(row.terminalNo, this.config.id, res => {
          this.loading = 0
          if (res.status == 200) {            
            this.getList()                        
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        }) 
      },
      sortChange (vl) {
        switch (vl.prop) {
          case 'terminalName':
            this.orderName = '1'
            break
          case 'terminalNo':
            this.orderName = '2'
            break
          case 'opeTime':
            this.orderName = '3'
            break
        }
        this.orderType = vl.order == 'descending'? 'desc':'asc'
        this.getList()
      },
      closeDia () {
        
        this.status = ''
        this.srchValue = ''
        this.mech1 = ''
        var _this = this
        this.mechanismData1 = {
          callback (value) {
            _this.mech1 = value
            _this.getDevices()
          }
        }
        this.getDevices()
      },
      cycleRq () {
        // clearTimeout(window.dto)
        // window.dto = ''
        if (this.$route.path == '/dvconfig/detail') {
          this.getList()
          var _this = this 
          setTimeout(() => {
            _this.cycleRq()
          }, this.rfDuration * 1000);
        }
      },
      stcolor (st) {
        var colortst = 'color: '
        var cv = ''
        switch (st) {
          case '1':
            cv = 'green'
            break
          case '2':
            cv = 'red'
            break
          default:
            cv = 'gray'
            break
        }

        return colortst+cv
      },
      pageChange (vl) {
        this.page = vl
        this.getList()
      },
      bcbind () {
        var arr = []
        this.multipleSelection.forEach(item => {
          arr.push(item.terminalId)
        })
        
        this.bindRqs(arr.toString())
      },
      handleSelectionChange (val) {
        // this.sNum = val.length
        this.multipleSelection = val
      },
      editCf () {
        this.$setWObj('dvconfigEdit', this.detailId)
        this.$router.push({path: '/dvconfig/detail/edit'})
      },
      showBindSt (row) {
        return this.bindSt[row.useStatus]
      },
      bindOp (row) {
        
        this.bindRqs(row.terminalId)
      },
      bindRqs (id) {
        this.loading = 1
        this.$tcBindDevice(id, this.config.id, res => {
          this.loading = 0
          if (res.status === 200) {
            this.dialogVisible = false
            // 
            this.getList()
            this.closeDia()
            
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        }) 
      },
      query () {
        this.getList()
      },
      srchDevice () {
        this.getDevices()
      },
      getDevices () {
        var vl = this.srchValue ? this.srchValue : ''
        var channel = this.mech1 ? this.mech1 : ''
        var status = this.status ? this.status : ''
        this.loading = 1
        this.$getDvDevices(this.index, this.$gRow, channel, vl, status, '', '', '','','', (res) => {
          console.log('dv', res)
          this.loading = 0
          if (res.data) {
            this.tableData = res.data
            this.total = res.total
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      addTer () {
        this.dialogVisible=true

        
      },
      deleteApp (obj) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          console.log(obj)
          this.$delFstRecord(obj.id, (res) => {
            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, '')
        }, '')
      },
      unbind (row) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          
          this.$tcDelDevice(row.id,(res) => {
            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, '')
        }, '')
      },
      editApp (row) {
        this.$setWObj('filestEdit', {type: 1, data: row})
        this.$router.push({path: '/stfile/detail/edit'})
      },
      pushApp (row) {
        this.$setWObj('pushList', {type: '13', data: row})
        this.$router.push({path: '/stfile/detail/push'})
       
      },
     
      getList () {
        // this.loading = 1
        var mech = this.mech //渠道商id
        var name = this.queryKey ? this.queryKey : ''
        var status = this.bindVl

        this.$tcDeviceBindList(this.page, this.$gRow, mech, name, status, this.config.id, this.orderName, this.orderType, res => {
          
          this.loading = 0
          if (res.status === 200) {
            this.pageTotal = res.total
            this.hiss = res.data
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      getStatus (value) {
        if (!value) return ''
        switch (value) {
          case '0':
            return {vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;'}
          case '1':
            return {vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;'}
          case '2':
            return {vl: this.$t('app_verifyPass'), style: 'color:#13CE66;'}
          case '3':
            return {vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;'}
        }
      },
      getDetail () {
        this.loading = 1
        
        this.$tcDetail(this.detailId, (res) => {
          this.loading = 0
          if (res.status === 200) {
            // this.config = this.$getWObj().dvconfigDetail
            this.config = res.data
            this.config.param = JSON.parse(this.config.param1)
            this.init()
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      setInstallType (type) {
        return this.$installType[type]
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD hh:mm:ss')
      },
      selectChange (vl) {
        // this.getDevices()
        this.getList()
      },
      pageSelect (index) {
        this.index = index
        this.getDevices()
      },
      pageSized (val) {
        this.$gRow = val
        this.getDevices()
      },
     


      delHis (row) {
        
        this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
          confirmButtonText: this.$t('app_sure'),
          cancelButtonText: this.$t('app_cancel'),
          type: 'warning'
        }).then(() => {
          this.loading = 1
          this.$delLauncherHistory(row.versionid, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.getHistory()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            // error
            this.loading = 0
          })
          
        }).catch(() => {
        })
        
      },
 
      imgFullUrl (path) {
        if (path) {
          // return this.$host + path
          // console.log('imgpath', path, this.$urls.prefix + path)
          return this.$urls.prefix + path
          //return path
        } else {
          return ''
        }
      },

     
      uploadNew () {
        // this.$t('menu.sysManageSub.launchNewVer')
        var obj = {type: 2, data: this.config}
        var key = 'launcherEdit'
        this.$setWObj(key, obj)
        this.$router.push({path: '/launch-newver'})
      },
      init () {
        //////// make dynamic detail param
        var pms = []
        var data = this.config.param
        var callType = data.callType
        var pwd = data.pwd
        var mapType = data.mapType
        var isHttps = data.isHttps
        var ops_authIp = data.ops_authIp
        var ops_authPort = data.ops_authPort
        var tms_callbackIp = data.tms_callbackIp
        var tms_callbackPort = data.tms_callbackPort
        if (callType) {
          pms.push({tt: this.$t('app_callfunc'), vl: this.ctrlType[callType]})
        }
        if (pwd) {
          pms.push({tt: this.$t('app_stmgpsw'), vl: pwd})
        }
        if (mapType) {
          pms.push({tt: this.$t('app_mapsl'), vl: this.mapType[mapType]})
        }
        if (isHttps) {
          pms.push({tt: 'API' + this.$t('app_protocal'), vl: isHttps == 0?'HTTP':'HTTPS'})
        }
        if (ops_authIp && ops_authPort) {
          pms.push({tt: this.$t('app_rgsvpm'), vl: ops_authIp+':'+ops_authPort})
        }
        if (tms_callbackIp && tms_callbackPort) {
          pms.push({tt: this.$t('app_bgntpm'), vl: tms_callbackIp+':'+tms_callbackPort})
        }
        var result = [];
        for (var i=0;i<pms.length;i+=3) {
          result.push(pms.slice(i,i+3));
        }
        this.dtGroup = result
        //////// 

        // this.getHistory()
        
        this.getDevices()
        this.cycleRq()
      }
     
    },
    mounted () {
      // this.init()
      this.tqobj = {
        keys: ['terminalTypes'],
        callback: data => {
          this.stModel = data[0]
          // this.status = '1'
          // this.init()
          // this.srchDevice()
        }
      }
      this.detailId = this.$getWObj().dvconfigDetail
      this.getDetail()
    }
  }
</script>



// WEBPACK FOOTER //
// detail.vue?584f153f